import { useFormikContext } from "formik";
import { IAirportLookup } from "../../Models/IAirportLookup";
import { ICharterRequest } from "../../Models/ICharterRequest";
import { useFetchCached } from "../../Services/fetchApi";
import { endpoints } from "../../utils/Constants";

const RoutesSummary = () => {
    const { values } = useFormikContext<ICharterRequest>();
    const [airportsLookup] = useFetchCached<IAirportLookup[]>(endpoints.airportLookupAll);
    const airportsList = values.routes.reduce((acc, curr) => {
        if (acc[acc.length - 1] === curr.from)
            return [...acc, curr.to];
        return [...acc, curr.from, curr.to];
    }, [] as string[]);
    return <><b>Routes summary:</b>{' ' + airportsList.map(airport => {
        if (!airportsLookup) return airport;
        return airportsLookup.find(la => la.site === airport)?.iataCode ?? `${airport}*`
    }).join(' -> ')}</>
}

export default RoutesSummary;